import {NgModule, ModuleWithProviders} from "@angular/core";
import {CommonModule} from "@angular/common";
import {SvgAssetOutletDirective} from "./svg-asset-outlet.directive";
import {SvgAssetShowcaseComponent} from "./svg-asset-showcase.component";
import {SvgAssetIconConfig, ICON_SVG_ASSET_CONFIG} from "./svg-asset.models";
@NgModule({
  declarations: [
    SvgAssetOutletDirective,
    SvgAssetShowcaseComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    SvgAssetOutletDirective,
    SvgAssetShowcaseComponent
  ]
})
export class SvgAssetBundlerModule {
  static forYouAndMe(config: SvgAssetIconConfig): ModuleWithProviders<SvgAssetBundlerModule> {
    return {
      ngModule: SvgAssetBundlerModule,
      providers: [
        {
          provide: ICON_SVG_ASSET_CONFIG,
          useValue: config
        }
      ],
    };
  }
}
